import { render, staticRenderFns } from "./DetailsChatEditor.vue?vue&type=template&id=0140d6c9"
import script from "./DetailsChatEditor.vue?vue&type=script&lang=ts"
export * from "./DetailsChatEditor.vue?vue&type=script&lang=ts"
import style0 from "./DetailsChatEditor.vue?vue&type=style&index=0&id=0140d6c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports